const getters = {
	token: state => state.user.token,
	admin_name: state => state.user.admin_name,
	user_name: state => state.user.user_name,
}

export default getters
